var _defs, _path, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTankerSeries15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 622.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-4{letter-spacing:-.1em}.cls-8{letter-spacing:-.11em}.cls-10,.cls-11{letter-spacing:-.02em}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.25h857v24H18zm0 130.17h857v24H18zm0 52h857v24H18zM18 247h857v24H18zm0 53h857v24H18zm0-235.17h857v50H18zm0 286.68h857v50H18zm0 77.52h857v24H18zm0 80.14h857v24H18zm0 49.89h857v24H18z",
    fill: "#333",
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(25.38 31.19)",
    fontFamily: "HelveticaNeue-Medium,'Helvetica Neue'",
    fontSize: 18,
    fontWeight: 500,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Body "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 48.69,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 57.37,
    y: 0
  }, "ype"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26
  }, "Compartments"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52
  }, "Loading and Discharge"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 104
  }, "Design Standa"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 121.7,
    y: 104
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 127.71,
    y: 104
  }, "d"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 0,
    y: 130
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.87,
    y: 130
  }, "ank Code"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 156
  }, "Certificate"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 0,
    y: 182
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.68,
    y: 182
  }, "est P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 51.03,
    y: 182
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 57.04,
    y: 182
  }, "essu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 96.06,
    y: 182
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 102.08,
    y: 182
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 208
  }, "Operating P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 99.38,
    y: 208
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 105.39,
    y: 208
  }, "essu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 144.41,
    y: 208
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 150.42,
    y: 208
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 234
  }, "Operating "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 87.37,
    y: 234
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 96.05,
    y: 234
  }, "emperatu"), /*#__PURE__*/React.createElement("tspan", {
    x: 175.39,
    y: 234,
    letterSpacing: "-.02em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 181.4,
    y: 234
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 260
  }, "Insulation System"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 286
  }, "Heating System"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 312,
    letterSpacing: "-.04em"
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.33,
    y: 312
  }, "alkway"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 338
  }, "Axle G"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 54.68,
    y: 338
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 60.69,
    y: 338
  }, "oup"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 390
  }, "Ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 15.01,
    y: 390
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.02,
    y: 390
  }, "es and Rims"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 416
  }, "Brakes"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 442
  }, "General Information"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 494
  }, "Surface "), /*#__PURE__*/React.createElement("tspan", {
    x: 69.03,
    y: 494,
    letterSpacing: "-.09em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 78.05,
    y: 494,
    letterSpacing: "-.02em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 84.06,
    y: 494
  }, "eatment"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 520
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 13.66,
    y: 520
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.67,
    y: 520
  }, "oss "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 54.04,
    y: 520
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 70.7,
    y: 520
  }, "eight"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 0,
    y: 546
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.87,
    y: 546
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 18.88,
    y: 546
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.89,
    y: 546
  }, "e "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 39.91,
    y: 546
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 56.57,
    y: 546
  }, "eight"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 572
  }, "Payload Capacity"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(279.38 31.4)",
    fill: "#fff",
    fontFamily: "HelveticaNeue,'Helvetica Neue'",
    fontSize: 17
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Stainless Steel"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26
  }, "1"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52
  }, "Includes Siebeck flush valve with gravity or pump discha"), /*#__PURE__*/React.createElement("tspan", {
    x: 429.79,
    y: 52,
    letterSpacing: "-.03em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 434.97,
    y: 52
  }, "ge options,"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 78
  }, "bottom discha"), /*#__PURE__*/React.createElement("tspan", {
    x: 109.6,
    y: 78,
    letterSpacing: "-.03em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 114.78,
    y: 78
  }, "ge, and top manhole filling"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 104
  }, "EN 14025"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 130
  }, "L4BH"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 156
  }, "ADR TUV AUSTRIA"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 182
  }, "4 bar"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 208
  }, "2 bar"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 234
  }, "-20\xB0C / +250\xB0C"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 260
  }, "100mm glass wool or polyu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 209.08,
    y: 260
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 214.44,
    y: 260
  }, "ethane insulation"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 286,
    letterSpacing: "-.06em"
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.77,
    y: 286
  }, "ebasto bu"), /*#__PURE__*/React.createElement("tspan", {
    x: 90.98,
    y: 286,
    letterSpacing: ".02em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 96.95,
    y: 286
  }, "ner and 2&quot; hot steam lines"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 312
  }, "Aluminum walkway with 1-meter handrail and 400 mm wide ladder"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 338
  }, "SAF / BPW 3 x 9 t disc-braked, maintenance-f"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 351.73,
    y: 338
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 357.08,
    y: 338
  }, "ee, ai"), /*#__PURE__*/React.createElement("tspan", {
    x: 397.7,
    y: 338,
    letterSpacing: "-.05em"
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 402.42,
    y: 338
  }, "-suspended axles, "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 364
  }, "factory-mounted with original brackets"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 390
  }, "385/65 R 22.5 BRIDGESTONE / MICHELIN ti"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 340.37,
    y: 390
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 345.72,
    y: 390
  }, "es on ALCOA / ALUX rims"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 416
  }, "ABS/EBS brake system (ECE R 13 compliant)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 442,
    letterSpacing: "-.11em"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.87,
    y: 442
  }, "wo-tier PVC hose carriers, PVC toolbox, ADR-compliant electrical system"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 468
  }, "(ECE R 105)"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 494
  }, "2 layers of epoxy primer and 2 layers of acrylic paint with a baked-on finish"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 520
  }, "35.500 kg"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 546
  }, "6.000 kg"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 572
  }, "29.500 kg"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTankerSeries15);
export default __webpack_public_path__ + "static/media/TankerSeries-15.50deebdf5929fddf008ab0361eaf7612.svg";
export { ForwardRef as ReactComponent };